<div class="flex-cards__item">
  <ng-container #content></ng-container>
</div>
